




















































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import { getDetail, getSiblingId, getPrizeDetail } from '../api';
import { Toast } from 'vant';

Vue.use(Toast);

@Component({
  components: {
    XGplayer,
  },
})
export default class Detail extends Vue {
  detail: any = {};
  isViewMode = false;
  viewlist: any[] = [];
  async created() {
    this.isViewMode = !!this.$route.query.isViewMode;
    let ret: any;
    if (this.isViewMode) {
      ret = await getPrizeDetail(this.$route.query.id as string);
    } else {
      ret = await getDetail(this.$route.query.id as string);
    }
    this.detail = ret.data;
  }
  onBack() {
    const baseUrl = '2021-red-story-online-show';
    if ((window as any).$hasEnteredHomePage) {
      this.$router.back();
    } else {
      if (this.isViewMode) {
        location.href = `${location.origin}${process.env.VUE_APP_PUBLIC_PATH}${baseUrl}?isViewMode=1`;
      } else {
        location.href = `${location.origin}${process.env.VUE_APP_PUBLIC_PATH}${baseUrl}`;
      }
    }
  }
  async onItemSwitch(type: 'prev' | 'next') {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
    const retSiblingIds = await getSiblingId(this.detail.number);
    const typeMap = {
      prev: 'lastId',
      next: 'nextId',
    };
    const targetId = retSiblingIds.data[typeMap[type]];
    if (!targetId) {
      return Toast('已经没有更多数据了');
    }
    const retDetail = await getPrizeDetail(targetId);
    this.detail = retDetail.data;
    Toast.clear();
  }
}
